import { FC, useContext, useEffect } from 'react'
import { AppContext } from '../AppContext'
import './UploadDropZone.scss'
import { useDecodeAudioFile } from './hooks/useDecodeAudioFile'
import { logger } from '../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { getLogAudioFileInfo } from '../functions/getLogAudioFileInfo'
import { getLogAudioBufferInfo } from '../functions/getLogAudioBufferInfo'

/**
 * Drop zone element is required because browser emits dragenter and dragleave events on each event target change.
 * Dragleave on previous element is fired after dragenter on a new one.
 */
export const UploadDropZone: FC = () => {
  const { setDragging, setAudioBuffer, setFilename, setUploadOpened } = useContext(AppContext)
  const decodeAudioFile = useDecodeAudioFile()

  useEffect(() => {
    logger.log(LogActionType.UploadDragStart)

    return () => {
      logger.log(LogActionType.UploadDragEnd)
    }
  }, [])

  return (
    <div
      className="UploadDropZone"
      onDragEnter={(event) => event.preventDefault()}
      onDragOver={(event) => event.preventDefault()}
      onDragLeave={() => setDragging(false)}
      onDrop={(event) => {
        event.preventDefault()
        setDragging(false)

        const file = event.dataTransfer.files.item(0)

        if (file) {
          logger.log(LogActionType.UploadDragFileDrop, getLogAudioFileInfo(file))

          decodeAudioFile(file).then((audioBuffer) => {
            logger.log(LogActionType.UploadFileDecoded, getLogAudioBufferInfo(audioBuffer))

            setFilename(file.name)
            setAudioBuffer(audioBuffer)
            setUploadOpened(false)
          })
        }
      }}
    />
  )
}
